import { MessageBase } from "abweb/dto/generated/MessageBase";
export class Message extends MessageBase {
  static createMessage(html, severity, text) {
    let retVal = new Message();
    retVal.initMessage(html, severity, text);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=Message.js.map
